"use strict";

exports.__esModule = true;
exports.getAPY = getAPY;
var _types = require("../../types");
const ESTIMATE_BLOCK_TIME = {
  [_types.ChainType.ACALA]: 6 * 1000,
  [_types.ChainType.KARURA]: 6 * 1000,
  [_types.ChainType.MANDALA]: 6 * 1000
};
const YEAR = 365 * 24 * 60 * 60 * 1000;
function getAPY(rewardRate, commissionRate, eraFrequency, chain) {
  if (!chain) return 0;
  if (!ESTIMATE_BLOCK_TIME[chain]) return 0;
  const eraCountOneYear = Math.floor(YEAR / (ESTIMATE_BLOCK_TIME[chain] || 0) / eraFrequency);
  return Math.pow(rewardRate * (1 - commissionRate) + 1, eraCountOneYear) - 1;
}